<!-- @format -->

<template>
  <a-layout-footer>
    <div class="footer">
      <div class="friendLink">
        <div class="tit">友情链接</div>
        <ul style="display: flex; justify-content: flex-start; flex-direction: row; width: 100%; flex-wrap: wrap; overflow: auto">
          <li
            v-for="(item,index) in lists"
            :key="index"
            style="width: 180px; margin-bottom: 28px; margin-right: 15px; height: 17px; white-space: nowrap">
            <a
              :href="item.url"
              target="_blank"
              >{{ item.name }}</a
            >
          </li>
        </ul>
      </div>
      <div class="copyrightBox">
        <h4 style="color: #b1b1b1">联系我们</h4>
        <div class="flag">
          <div style="margin-right: 10px" class="flag-img">
            <a
              href="http://bszs.conac.cn/sitename?method=show&id=09DA4C0DDF56534AE053012819AC4BA0"
              target="__blank">
              <img
                src="@/assets/img/type-flag.png"
                style="width: 50px; height: 50px" />
            </a>
          </div>
          <div class="copyleft">
            <p>联系电话：0915—8183608（总院） 2310368（高新院区） 8119999（急救电话）</p>
            <p>地址：安康市汉滨区巴山东路47号（总院） 安康市高新区创新路南侧（高新院区）</p>
          </div>
          <div class="copyright">
            <p>
              备案号：陕卫网审[2011]第0003号
              <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                style="color: #b1b1b1"
                >陕ICP备：11010322号</a
              >
            </p>
            <p v-if="!$isMobile">版权所有：安康市中医医院版权所有　　技术支持：安康大数据运营有限公司</p>
            <template v-else>
              <p>版权所有：安康市中医医院版权所有</p>
              <p>技术支持：安康大数据运营有限公司</p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </a-layout-footer>
</template>

<script>
import { getlists } from "@/api";
export default {
  name: "sospitalDynamic",
  data() {
    return {
      lists: [],
      id: this.$route.params.id,
      name: "新闻动态",
    };
  },
  methods: {
    async getNewsdetail() {
      const params = {
        id: this.id,
      };
      getlists(params).then((res) => {
        this.lists = res.data.items;
      });
    },
  },

  created() {
    this.getNewsdetail();
  },
  watch: {
    $route(to, from) {
      if (to.name == "内容页") {
        this.id = this.$route.params.id;
        this.getNewsdetail();
      }
    },
  },
};
</script>

<style
  lang="less"
  scoped>
.ant-layout-footer {
  padding: 0 0;
  background: url(../../assets/img/foot-bg.jpg) repeat;
  height: 33.5%;
}
.footer {
  width: auto;
  /*--min-width:1200px;--*/
  margin: 0 8%;
  padding: 12px 0 10px 0;
  box-sizing: border-box;
  .friendLink {
    width: 100%;
    color: #b1b1b1;
    font-size: 16px;
  }
  .friendLink .tit {
    line-height: 17px;
    margin-bottom: 13px;
  }
  .friendLink ul li {
    float: left;
    width: 10%;
    line-height: 17px;
    text-indent: 10%;
    box-sizing: border-box;
  }
  .friendLink ul li a {
    color: #b1b1b1;
  }
  .friendLink ul li a:hover {
    color: #fff !important;
  }

  .copyrightBox {
    width: 100%;
    margin-top: 15px;
    overflow: hidden;
    zoom: 1;

    .flag {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .copyleft {
    float: left;
    width: 50%;
  }
  .copyleft h4,
  .copyleft p {
    display: block;
    line-height: 30px;
    width: 100%;
    color: #b1b1b1;
    font-size: 16px;
  }
  .copyright {
    float: right;
    width: 47%;
    font-family: "微软雅黑" !important;
    color: #b1b1b1;
    line-height: 32px;
    font-size: 16px;
    padding-top: 27px;
  }
}
@media screen and (max-width: 768px){
  .footer{
    margin: 0;
    padding:13px  16px 0 15px;
  }
  .friendLink{
    font-size: 12px;
    ul{
      li{
        width: 40% !important;
        font-size: 12px;
        margin-bottom: 20px !important;
        color: #ffffff66;
        text-indent: 0% !important;
      }
    }
  }
  .tit{
    font-size: 14px;
color: #FFFFFF;
  line-height:1 !important;
  margin-bottom: 16px !important;
  }
  .copyrightBox{
    margin-top: 0px;
    h4{
      font-size: 14px;
      color: white !important;
      margin-bottom: 16px !important;
    }
    .flag{
      display: flex;
      flex-direction: column !important;
    }
    .flag-img{
      display: none;
    }
    .copyleft,.copyright{
      width: 100%;
      font-size:12px;
      padding-top: 0;
      p{
        font-size: 12px;
        margin-bottom: 10px !important;
        line-height: 19px;
      }
    }
  }
}
</style>
